//assets
import Pic1 from "../../../assets/images/about1.png";
import Pic2 from "../../../assets/images/about2.png";
import { Btn } from "../../global/Buttons/btns";
import { Title } from "../../global/title/title";


export const Aboutus = () => {
  return (
    <div className="about-us section container">

      <div className="about-us__gallery">
        <div className="about-us__box ">
          <img src={Pic1} alt="pic" className="about-us_img   " />
        </div>
        <div className="about-us__box about-us__box--2  ">
          <img src={Pic2} alt="pic" className="about-us_img  " />
        </div>
      </div>
      <div className="about-us__content">
        <h2>
          <span className="heading heading__secondary text--blue">
            about us
          </span>
          <span className="heading heading__ternary  text--black">
            {" "}
            DR.DERM
          </span>
        </h2>

        <p className="paragraph text--gray mt--mid">
          Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet
          sint. Velit officia consequat duis enim velit mollit. Exercitation
          veniam consequat sunt nostrud amet.
        </p>
        <p className="paragraph text--gray mt--mid">
          Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet
          sint. Velit officia consequat duis enim velit mollit. Exercitation
          veniam consequat sunt nostrud amet.
        </p>
        <div className="mt--mid">
          <Btn name="secondary" value="See More" />
        </div>
      </div>
    </div>
  );
};
